var App = App || {};

App.SharedZagParallax = (function ($) {
    'use strict';

    function Init() {

        $("[data-bb-background][data-bb-pattern]").each(function () {
            const bgcolor = $(this).attr("data-bb-background");
            const bgImage = `/Images/brand-pattern-${bgcolor}.svg`;
            $(this).ZagParallax({ divisor: 4, image: bgImage });
        });
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.SharedZagParallax.Init();
});